export default __webpack_public_path__ + "static/media/Declaration of Independence_05.642c4bca.jpg";